import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import styles from './FJTextBaseEditingRightHeader.module.less';
import PropTypes from 'prop-types';
import DownloadIcon from '../../../../assets/svg/download-gradient.svg?react';
import VideoGradientIcon from '../../../../assets/svg/video-gradient.svg?react';
import SplitIcon from '../../../../assets/svg/split.svg?react';
import MergeIcon from '../../../../assets/svg/merge.svg?react';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJCheckBoxRound from '../../../../common/components/FJCheckBoxRound/FJCheckBoxRound';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import classNames from 'classnames';
// import FJCheckBox from '../../../../common/components/FJCheckBox/FJCheckBox';

const TYPE_LIST = [
    {
        icon: <SplitIcon />,
        title: 'splitted-clips',
        value: 'splitted',
        subtitle: 'add-as-separated-clips',
    },
    {
        icon: <MergeIcon />,
        title: 'merged-video',
        value: 'merged',
        subtitle: 'merge-and-add-as-one-video',
    },
];

const FJTextBaseEditingRightHeader = ({
    isShow,
    isApplyButton,
    batchDownloadLoading,
    isEditPage,
    selectedType,
    changeSelectedType,
    // isShowSubtitle,
    // changeIsShowSubtitle,
    exportVideo,
    downloadVideo,
}) => {
    if (!isShow) return null;

    return (
        <div className={styles.container}>
            <FJButton
                text='download'
                className={styles.download_button}
                type={FJButtonType.LIGHT_GRADIENT}
                isLoading={batchDownloadLoading}
                onClick={downloadVideo}
                icon={<DownloadIcon className={styles.download_icon} />}
            />

            <FJDropdownNew
                placement='bottomRight'
                overlayClassName={styles.dropdown_overlay}
                renderTrigger={config => (
                    <div onClick={config.onClick} ref={config.ref}>
                        <FJButton
                            text={isEditPage ? (isApplyButton ? 'apply' : 'add-to-media') : 'edit'}
                            className={styles.edit_button}
                            type={FJButtonType.GRADIENT}
                            icon={<VideoGradientIcon className={styles.edit_icon} />}
                        />
                    </div>
                )}
                renderOverlay={() => (
                    <div className={styles.dropdown_overlay_box}>
                        <div className={styles.title}>{FJLocalStore._('add-to-timeline')}</div>
                        <div className={styles.type_list_box}>
                            <div>
                                {TYPE_LIST.map((item, index) => (
                                    <FJHoverBoardGradation
                                        key={index}
                                        onClick={() => changeSelectedType(item.value)}
                                        active={selectedType === item.value}
                                        className={classNames(styles.type_list_item_box)}
                                        contentClassName={styles.type_list_item}
                                        selectBgColor={'#ffffff'}
                                    >
                                        <div className={styles.type_list_item_icon}>{item.icon}</div>

                                        <div className={styles.type_list_item_content}>
                                            <div className={styles.type_list_item_title}>
                                                {FJLocalStore._(item.title)}
                                            </div>
                                            <div className={styles.type_list_item_subtitle}>
                                                {FJLocalStore._(item.subtitle)}
                                            </div>
                                        </div>
                                        <FJCheckBoxRound selected={selectedType === item.value} />
                                    </FJHoverBoardGradation>
                                ))}
                            </div>
                        </div>
                        {/* <div className={styles.add_subtitle}>
                            {FJLocalStore._('subtitle')}
                            <FJCheckBox checked={isShowSubtitle} onChange={changeIsShowSubtitle} />
                        </div> */}
                        <FJButton
                            type={FJButtonType.GRADIENT}
                            text='add'
                            className={styles.export_button}
                            onClick={exportVideo}
                        />
                    </div>
                )}
            />
        </div>
    );
};

FJTextBaseEditingRightHeader.propTypes = {
    isShow: PropTypes.bool.isRequired,
    isApplyButton: PropTypes.bool.isRequired,
    batchDownloadLoading: PropTypes.bool.isRequired,
    isEditPage: PropTypes.bool,
    selectedType: PropTypes.string.isRequired,
    changeSelectedType: PropTypes.func.isRequired,
    isShowSubtitle: PropTypes.bool.isRequired,
    changeIsShowSubtitle: PropTypes.func.isRequired,
    exportVideo: PropTypes.func.isRequired,
    downloadVideo: PropTypes.func.isRequired,
};

export default FJTextBaseEditingRightHeader;
